import React from "react";
import "./productList.css";
import { auth } from "../../firebase-config";
import { useState, useEffect } from "react";
import { db } from "../../firebase-config";
import { setDoc, doc } from "firebase/firestore";
import Popup from "./Popup/Popup";
import { render } from "@testing-library/react";

const DisplayProducts = (
  index,
  name,
  desc,
  price,
  productImage,
  qty,
  vol,
  nos,
  ml
) => {
  const addToCart = () => {
    setDoc(doc(db, auth.currentUser.uid+'+Cart', name), {
      userId: auth.currentUser.uid,
      name: name,
      price: price,
      productImage: productImage,
      boxes: 1,
      qty: qty,
      vol: vol,
    });
  };

  return (
    <>
      <div key={index} className="product-container">
        <div className="product-image">
          <span className="hover-link"></span>
          {/*
          <button
            style={{
              border: "none",
            }}
            onClick={() => {
              addToCart();
              render(<Popup name = {name} />);
              // console.log("hello");
            }}
            id={name}
            className="product-link"
          >
            Add To Cart
          </button> */}
          <img className="img-responsive" src={productImage} />
        </div>
        <div className="product-description">
          <div className="product-label">
            <div className="product-name">
              <h3> {name}</h3>
              <p className="price">&#8377;{price}</p>
              <p>
                {vol} ({qty}Nos)
              </p>
            </div>
          </div>
          <div className="product-option">
            <div className="product-size">
              <h3>{desc}</h3>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DisplayProducts;
